import React from "react";
// import PropTypes from "prop-types";

import PurposesSelect from "../../shared/containers/filters/purposes";
import CountriesSelect from "../../shared/containers/filters/countries";
import ParametersPopover from "../../shared/containers/filters/parameters";
import RegulationsSelect from "../../shared/containers/filters/regulations";
import ShowOnlyMandatory from "../../shared/containers/filters/show_only_mandatory";
import ShowOnlyCurrent from "../../shared/containers/filters/show_only_current";

class MainFilters extends React.Component {
  render () {
    return (
      <div className="main-filters">
        <div className="row">
          <PurposesSelect />
          <CountriesSelect />
          <ParametersPopover />
        </div>
        <div className="row">
          <RegulationsSelect />
          <ShowOnlyMandatory />
          <ShowOnlyCurrent />
        </div>
      </div>
    );
  }
}

MainFilters.propTypes = {
  // searchIsBeingSaved: PropTypes.bool.isRequired,
};

export default MainFilters;
